import { render, staticRenderFns } from "./ServicingOverview.vue?vue&type=template&id=1886ce28"
import script from "./ServicingOverview.vue?vue&type=script&lang=js"
export * from "./ServicingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports